module.exports = __webpack_public_path__ + "static/background-contact-1f0c2a263c13de5f4b8ba6f74281e0db.png";